import { ProgressBar } from "react-bootstrap";
import styled, { css } from "styled-components";

import { colors, types } from "../../../libs";

export const SideMenuUploadCta = styled.div`
  padding: 15px 20px;
`;

export const SideMenuListWrapper = styled.ul`
  flex: 1;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${colors.background.darkGreen};
    border-radius: 10px;
  }
`;

export const SideMenuLinkItemWrapper = styled.li``;

export const SideMenuUpgradeCard = styled.div`
  background: ${colors.background.brown};
  padding: 15px;
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px;
  width: 100%;
`;

export const UpgradeHeader = styled.p`
  ${types.body.secondaryTitle}
`;

export const UsageWrapper = styled.div`
  margin-top: 5px;
`;

export const UsageProgressBar = styled(ProgressBar)<any>`
  ${({ variant }) => variant === "primary" && css``}
  height: 5px;
`;

export const UsageText = styled.p`
  margin-top: 10px;
`;

export const UpgradeCtaLink = styled.a`
  color: ${colors.text.green};
`;

export const PaymentIssueAlert = styled.div`
  background: #342126;
  border: 1px solid #dc6678;
  border-radius: 10px;
  margin: 10px 10px 0;
  padding: 14px;
  width: 100%;
`;

export const PaymentIssueTitle = styled.p`
  color: #ff9baa;
  font-weight: 700;
  margin: 0 0 5px;
`;

export const PaymentIssueText = styled.p`
  color: ${colors.text.mediumWhite};
  font-size: 13px;
  margin: 0 0 8px;
`;

export const PaymentIssueLink = styled.a`
  color: #ff9baa;
  font-size: 13px;
  font-weight: 600;
`;

export const AdminModeAlert = styled.div`
  background-color: #fff3cd00;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdminModeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AdminModeText = styled.span`
  color: #ffc107;
  font-size: 13px;
  font-weight: 500;
`;

export const AdminModeButton = styled.button`
  background-color: #ffc107;
  color: #000;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;
